import React from 'react';
import { Linkedin } from 'lucide-react';
import { team } from '../data/mock';

const TeamSection = () => {
  return (
    <section id="team" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">Our Leadership Team</h2>
          <p className="body-large max-w-4xl mx-auto">
            Experienced leaders from top technology companies, bringing deep expertise to the MENA region
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {team.map((member, index) => (
            <div
              key={index}
              className="group text-center p-6 rounded-lg dark-transition dark-hover"
              style={{ 
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}
            >
              <div className="mb-6">
                <div 
                  className="w-32 h-32 mx-auto rounded-full flex items-center justify-center text-2xl font-bold mb-4"
                  style={{ 
                    background: 'rgba(0, 255, 209, 0.2)',
                    color: '#00FFD1'
                  }}
                >
                  {member.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              
              <h3 className="heading-2 mb-2">{member.name}</h3>
              <p className="body-medium mb-4" style={{ color: '#00FFD1' }}>
                {member.position}
              </p>
              <p className="body-small text-gray-400 mb-4">
                {member.background}
              </p>
              
              <div className="flex justify-center">
                <button className="p-2 rounded-full dark-transition" style={{ 
                  background: 'rgba(0, 255, 209, 0.1)' 
                }}>
                  <Linkedin size={20} style={{ color: '#00FFD1' }} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Company Culture */}
        <div className="text-center">
          <div className="p-12 rounded-lg" style={{ 
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h3 className="heading-1 mb-4">Join Our Team</h3>
            <p className="body-large mb-8 max-w-3xl mx-auto">
              We're always looking for talented individuals who share our passion for technology and innovation. 
              Be part of the digital transformation journey across the MENA region.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn-primary">
                <span>View Open Positions</span>
              </button>
              <button className="btn-secondary">
                <span>Learn About Our Culture</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;